import { Box } from '@mui/material';
import JxFormFieldsBase from '../../../../JxControls/JxForms/JxFormFieldsBase';
import componentNotifier from '../../../../services/wss/ComponentNotifier';
import FormConfigItemPanel from './FormConfigItemPanel';
import { createLayout } from './LoadFormConfigDlgSchema';

/**
 * LoadFormConfigDlgBody — form fields for LoadFormConfigDlg.
 * Extends JxFormFieldsBase for shared FieldRow/Section rendering.
 * System fields are commented out — uncomment + add copyable when needed.
 * FieldRow picks up label, control, readonly and layout from createLayout() via spread.
 * Consecutive top-label fields are wrapped in a flex row automatically.
 */
export default class LoadFormConfigDlgBody extends JxFormFieldsBase {
    layout = createLayout();

    constructor(props) {
        super(props);
        this.name = 'LoadFormConfigDlgBody';
    }

    componentDidMount() {
        super.componentDidMount();

        this.unsub = componentNotifier.subscribe('FormConfigEngine', (p) => this.handleDataChanged(p));
    }

    componentWillUnmount() {
        if (this.unsub) this.unsub();
    }

    handleDataChanged = (data) => {
        try {
            this.logDebug('handleDataChanged', 'data received');
        } catch (error) {
            this.logError('handleDataChanged', error.message);
        }
    };

    render() {
        const { Section, FieldRow } = this;
        const { layout } = this;

        return (
            <>
                {/* system fields */}
                {/* <FieldRow field="rk" {...layout.rk} copyable /> */}
                {/* <FieldRow field="ems" {...layout.ems} copyable /> */}

                <Box sx={{ px: '14px' }}>
                    {/* this is the filter input  */}
                    <FieldRow field="name" {...layout.name} />
                </Box>
            </>
        );
    }
}
